function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @param {unknown} thing
 * @returns {boolean}
 */
export function whitespace(thing) {
  /** @type {string} */
  var value = // @ts-ignore looks like a node.
  thing && _typeof(thing) === 'object' && thing.type === 'text' ? // @ts-ignore looks like a text.
  thing.value || '' : thing; // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.

  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === '';
}